import React, { Component, Fragment } from 'react';
import { MultLineTsPlot, PiePlot, BarPlot } from './PlotComponent';
import { RenderVirtualTable } from './TableComponent'
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import {  Label, Input, Button, Alert, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { series_normalize, unique_values, filtered_json, CustomSelect,
         CustomListSelect, sort_by, pick, array_diff, previous_date, aggregate } from './Functions';
import { returns, returns_json_array, total_ret, total_ret_annual, vol, avg_ret, sharpe, mdd, maxDrawdown,
         series_monthly, get_total_returns, get_total_returns_windows, corr } from './analytics';
import { colors, colors_sura_inv } from '../shared/data';
import { postRequest } from '../redux/ActionCreators';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    catalog: state.catalog
  };
};


class Catalog extends Component {
  constructor(props){
      super(props);
      this.state = {
        msg:null,
        msg_corr:null,
        loading_series:false,
        calculating_correlations:false,
        filter_cols:false
      };
      this.loadSeries = this.loadSeries.bind(this);
      this.renderHeader = this.renderHeader.bind(this);
      this.calculateCorr = this.calculateCorr.bind(this);
      this.editTable = this.editTable.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  
  editTable(){
    console.log("edit");
  }
  
  async calculateCorr(asset_series, date_key="Date"){
    this.setState({calculating_correlations:true});
    let matrix = {};
    try {
      const rets_array = returns_json_array(asset_series, date_key);
      const asset_names = array_diff(Object.keys(asset_series[0]), [date_key]);
      const label_map = this.props.user_wm.data.assets.filter(k=>asset_names.includes(k.Ticker)).reduce((acc, { Ticker, Asset }) => {
        acc[Ticker] = Asset;
        return acc;
      }, {});
      // this.setState({calculating_correlations:false});
      const series = {};
      // extract arrays
      asset_names.forEach(k => {
        series[k] = rets_array.map(r => r[k]);
      });
    
      asset_names.forEach(k1 => {
        matrix[label_map[k1]] = {};
        asset_names.forEach(k2 => {
          matrix[label_map[k1]][label_map[k2]] = corr(series[k1], series[k2]);
        });
      });
      await this.props.changeModel(
        "catalog.corr_matrix", 
              Object.keys(matrix).map(Activo => ({
        Activo,
        ...matrix[Activo]
        }))
      );
      this.setState({
        calculating_correlations:false
      });
    } catch(error){
      this.setState({
        calculating_correlations:false,
        msg_corr:"Error calculando correlaciones."
      });
      return;
    }
  }

  async loadSeries(){
    if (this.props.catalog.asset_tks_list.length == 0){
      if (this._isMounted) this.setState({ msg: "Seleccionar activos." });
      return;
    }    
    if (this.props.catalog.asset_tks_list.length==0){
      this.setState({msg:"Seleccionar activos."});
    } else {
      try {
        this.setState({loading_series:true});
        const series = await postRequest(
          { 
            tks:this.props.catalog.asset_tks_list.map(x=>x.value), 
            ref_curr:this.props.catalog.ref_curr
          }, 'get_series');
        await this.props.changeModel('catalog.asset_series', series);
        await this.props.changeModel('catalog.corr_matrix', null);
        this.setState({
          loading_series:false,
          msg:null
        });
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg: error.message,
          loading_series:false
        });
      }

      // Catalog
      try {
        this.setState({loading_exp:true});
        const asset_exp = await postRequest({
          bucket:'condor-sura', 
          key:'output/master_catalog/master_catalog.csv', 
          sep:',',
          query_string:`
            SELECT Isin,Name,Country,Currency,AssetClass,Credit,FundInd,Weight,AssetClassInd,Market
            FROM s3Object s
            WHERE s."Name" in ('${this.props.catalog.asset_tks_list.map(item => item.label.split("|")[0].trim().replace(/'/g, "\\'")).join("', '")}')
            OR s."Isin" in ('${this.props.catalog.asset_tks_list.filter(item => item.label.includes("|")).map(item => item.label.split("|")[1].trim().replace(/'/g, "\\'")).join("', '")}')
          `,
        }, 'retrieve_data_s3');
        await this.props.changeModel('catalog.asset_summ', asset_exp);
        this.setState({loading_exp:false});
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg: error.message,
          loading_series:false
        });
      }
      
    }
  }

  renderHeader(ref_dates){
    const tk_options = this.props.user_wm.data.assets
                        .filter(x=>(this.props.catalog.show_indices && x.AssetType=="Index") || (this.props.catalog.show_products && x.AssetType=="Fund/ETF"))
                        .map(x=>{return({value:x.Ticker, name:x.Asset, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}` : `${x.Asset} | ${x.Isin}`})}).sort(sort_by("label"));

    return(
      <Fragment>
        <div className="row justify-content-center" id="series">
          <div className="col-12 mt-5">
            <h4>Catálogo</h4>
            {ref_dates ?
              <div className="row justify-content-center" >
                <div className="col-auto">
                <p className="m-0"><small>{ref_dates}</small></p>
                </div>
              </div>
            : null
            }
          </div>
        </div>
        <div className="row justify-content-center" id="series">
          <div className="col-12 mb-3">
            <a className='linkcol' href='#summ'>métricas&darr;</a>
            <a className='linkcol' href='#exp'>{"         "}exposición&darr;</a>
          </div>
        </div>
        <div className='row m-2 justify-content-center align-items-end'>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.props.catalog.show_indices}
                onChange={()=>this.props.changeModel("catalog.show_indices", !this.props.catalog.show_indices)}
                />{' '}
                Índices
            </Label>
          </div>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.props.catalog.show_products}
                onChange={()=>this.props.changeModel("catalog.show_products", !this.props.catalog.show_products)}
                />{' '}
                Fondos/ETF
            </Label>
          </div>
        </div>
        <div className='row m-4 justify-content-center align-items-end'>
          <div className='col-12 col-md-6 col-lg-4'>
            <Label>Seleccionar Activos</Label>
            <CustomSelect
              name="assets"
              value={this.props.catalog.asset_tks_list}
              options={tk_options}
              onChange={(e)=>{this.props.changeModel('catalog.asset_tks_list', e.map(x=>{
                return {value:x.value, label:x.label, name:x.name};
              }))}}
              itemSize={60}
              className="basic-multi-select"
              placeholder="seleccionar..."
            />
          </div>
          <div className='col-md-6 col-lg-1'>
            <Label>Moneda</Label>
            <Input 
              bsSize='sm' 
              type="select" 
              value={this.props.catalog.ref_curr} 
              onChange={(e)=>this.props.changeModel('catalog.ref_curr',e.target.value)}>
                {['Origen', 'USD','MXN','COP',"UVR", 'PEN', 'CLP', 'CLF'].map((x,i)=>{
                  return (<option key={i}>{x}</option>);
                })}
            </Input>
          </div>
          <div className='col-md-6 col-lg-1'>
            <Label>Periodo</Label>
            <Input 
              bsSize='sm' 
              type="select" 
              value={this.props.catalog.asset_series_per} 
              onChange={(e)=>this.props.changeModel("catalog.asset_series_per", e.target.value)}>
                {['1D', '1M'].map((x,i)=>{
                  return (<option key={i}>{x}</option>);
                })}
            </Input>
          </div>
        </div>
        
        <div className='row m-4 justify-content-center align-items-end'>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.props.catalog.activate_initial_date}
                onChange={()=>this.props.changeModel('catalog.activate_initial_date',!this.props.catalog.activate_initial_date)}
                />{' '}
                activar fecha inicial 
            </Label>
          </div>
          {this.props.catalog.activate_initial_date ?
            <div className='col-2'>
              <Label>Fecha Inicial</Label>
              <Input 
                bsSize='sm'
                type="date" 
                value={this.props.catalog.initial_date} onChange={(e)=>this.props.changeModel('catalog.initial_date',e.target.value)}
                placeholder="Fecha..."
              >
              </Input>
            </div>
            :
            <div className='col-md-6 col-lg-1'>
              <Label>Rango</Label>
              <Input bsSize='sm' type="select" value={this.props.catalog.asset_series_range} onChange={(e)=>this.props.changeModel('catalog.asset_series_range',e.target.value)}>
                {["MTD", "YTD", "1M", "3M", "6M", '1Y','3Y','5Y','10Y'].map((x,i)=>{
                  return (<option key={i}>{x}</option>);
                })}
              </Input>
            </div>
          }
          <div className='col-2'>
            <Label>Fecha Final</Label>
            <Input 
              bsSize='sm'
              type="date" 
              value={this.props.catalog.end_date} onChange={(e)=>this.props.changeModel('catalog.end_date',e.target.value)}
              placeholder="Fecha..."
            >
            </Input>
          </div>
          <div className='col-2'>
            <Button className="btn-corp"
              onClick={this.loadSeries}
            >
              Actualizar Datos
            </Button>
          </div>
        </div>
        <div className="row mt-4 justify-content-center">
          <div className="col-6 m-3">
            <Alert
              color='secondary'
              isOpen={this.state.msg!=='' && this.state.msg!==null} 
              toggle={()=>this.setState({msg:null})}
              fade={false}
              >
                {this.state.msg}
            </Alert>
          </div>
        </div>

      </Fragment>
      );    
  }
  render() {
      if(this.props.user_wm.isLogging ){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else if(this.state.loading_series ){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <CustomLoading msg="cargando series" icon="fa-compass"/>
            </div>
          </div>
        );
      } else if(this.props.catalog.errMess){
          return(
              <div className="container">
                {this.renderHeader(null)}
                <div className="row justify-content-center m-5">
                  <h4>{this.props.catalog.errMess}</h4>
                </div>
              </div>
          );
      } else if(this.props.catalog.asset_series==null){
          return(
              <div className="container">
                {this.renderHeader(null)}
                <div className="row justify-content-center m-5">
                  <h6>No hay datos disponibles...</h6>
                </div>
              </div>
          );
      } else {
        const active_tickers = this.props.catalog.asset_tks_list.filter(x=>Object.keys(this.props.catalog.asset_series.ts[0]).includes(x.value)).map(x=>x.value);
        const norm_assets_series = this.props.catalog.asset_series!==null && this.props.catalog.asset_series.ts.length>0 && this.props.catalog.asset_tks_list.some(x=>Object.keys(this.props.catalog.asset_series.ts[0]).includes(x.value)) ?
                                   active_tickers.length==1 ? 
                                   this.props.catalog.asset_series.ts.filter(item=>Date.parse(item["Date"])>=(this.props.catalog.activate_initial_date ? 
                                                                    Date.parse(this.props.catalog.initial_date) : 
                                                                    Date.parse(previous_date(this.props.catalog.asset_series_range, this.props.catalog.end_date))) && 
                                                                    Date.parse(item["Date"])<=Date.parse(this.props.catalog.end_date)) :
                                   series_normalize(this.props.catalog.asset_series.ts.filter(item=>Date.parse(item["Date"])>=(this.props.catalog.activate_initial_date ? 
                                                    Date.parse(this.props.catalog.initial_date) :
                                                    Date.parse(previous_date(this.props.catalog.asset_series_range, this.props.catalog.end_date))) &&
                                                    Date.parse(item["Date"])<=Date.parse(this.props.catalog.end_date)),
                                                    active_tickers,
                                                    this.props.catalog.asset_series_range, 'Date', 1, 100) :
                                   null;

        const rename_map = Object.fromEntries(this.props.catalog.asset_tks_list.map(r => [r.value, r.name]));
      
        const norm_assets_series_per = norm_assets_series==null ? null : (this.props.catalog.asset_series_per=='1M' ? series_monthly(norm_assets_series): norm_assets_series);
        let assets_summ = norm_assets_series_per==null || norm_assets_series_per.length==0 || this.props.catalog.asset_series.summ==null ? null : 
          Object.keys(norm_assets_series_per[0]).filter(x=>x!="Date").map(item=>{
            let rets_temp = returns(norm_assets_series_per.map(x=>x[item]));
            let isin_temp = this.props.user_wm.data.assets.find(k=>k.Ticker===item).Isin;
            const mdd = maxDrawdown(norm_assets_series, item, "Date");
            if (this.props.catalog.asset_series.summ.map(x=>x['Ticker']).includes(item)){
              return {
                Id:this.props.user_wm.data.assets.find(k=>k.Ticker===item).Asset, 
                "Isin/Ticker":isin_temp=="" ? item : isin_temp, 
                ...pick(this.props.catalog.asset_series.summ.find(k=>k['Ticker']==item), ['Clase', 'Moneda']), 
                'Retorno Total':100*total_ret(norm_assets_series.map(x=>x[item])), 
                'Retorno Promedio Anual.':100*avg_ret(rets_temp, this.props.catalog.asset_series_per=='1M' ? 12:252), 
                'Retorno Periodo Anual.':100*total_ret_annual(norm_assets_series, item, "Date"),
                'Volatilidad Anual.':100*vol(rets_temp, this.props.catalog.asset_series_per=='1M' ? 12:252), 
                'Drawdown':100*mdd["maxDrawdown"],
                "DDT (días)":mdd["durationDays"],
                "TTR (días)":mdd["recoveryDays"],
                'Sharpe':sharpe(rets_temp, 1),
                [`${this.props.catalog.asset_series_per=="1D" ? "Días" : "Meses"} Negativos`]:rets_temp.filter(x=>x<0).length,
                'Fecha Inicial':norm_assets_series[0].Date,
                'Fecha Final':norm_assets_series.slice(-1)[0].Date
              };
            }else{
              const keys_temp = Object.keys(this.props.catalog.asset_series.summ[0]).reduce((acc, curr) => {
                                    acc[curr] = '';
                                    return acc;
                                }, {});
              const mdd = maxDrawdown(norm_assets_series, item, "Date");
              return {
                Id:this.props.user_wm.data.assets.find(k=>k.Ticker===item).Asset, 
                "Isin/Ticker": isin_temp=="" ? item : isin_temp,
                ...keys_temp, 
                'Retorno Total':100*total_ret(norm_assets_series.map(x=>x[item])), 
                'Retorno Promedio Anual.':100*avg_ret(rets_temp, this.props.catalog.asset_series_per=='1M' ? 12:252), 
                'Retorno Periodo Anual.':100*total_ret_annual(norm_assets_series, item, "Date"),
                'Volatilidad Anual.':100*vol(rets_temp, this.props.catalog.asset_series_per=='1M' ? 12:252), 
                'Drawdown':100*mdd["maxDrawdown"],
                "DTT (días)":mdd["durationDays"],
                "TTR (días)":mdd["recoveryDays"],
                'Sharpe':sharpe(rets_temp, 1),
                [`${this.props.catalog.asset_series_per=="1D" ? "Días" : "Meses"} Negativos`]:rets_temp.filter(x=>x<0).length,
                'Fecha Inicial':norm_assets_series[0].Date,
                'Fecha Final':norm_assets_series.slice(-1)[0].Date
              };
            }
          });
        
        const assets_summ_filtered = assets_summ ?  assets_summ.map(row => {
          const copy = { ...row };
          ["Fecha Inicial", "Fecha Final"].forEach(col => delete copy[col]);
          return copy;
        }) : null;
        
        const asset_ac = this.props.catalog.asset_name ? 
          aggregate(this.props.catalog.asset_summ.filter(k=>(k.Name==this.props.catalog.asset_name.label || k.Name==this.props.catalog.asset_name.value) && k.AssetClassInd), ["AssetClass"], ["Weight"]).map(k=>{
            return {name:k.AssetClass, value:k.Weight*100};
          }) : null;
        const asset_mkt = this.props.catalog.asset_name ? 
          aggregate(this.props.catalog.asset_summ.filter(k=>(k.Name==this.props.catalog.asset_name.label || k.Name==this.props.catalog.asset_name.value) && k.Market!==""), ["Market"], ["Weight"]).map(k=>{
          return {name:k.Market, value:k.Weight*100};
        }) : null;
        const asset_total_rets = this.props.catalog.asset_name ? get_total_returns(norm_assets_series,  this.props.catalog.asset_name.value, "Date", 100) : null;
        const asset_total_rets_windows = this.props.catalog.asset_name && norm_assets_series && Object.keys(norm_assets_series[0]).includes(this.props.catalog.asset_name.value) ? 
                                         get_total_returns_windows(norm_assets_series, this.props.catalog.asset_name.value, "Date", 100).slice(-10) 
                                         : null;
        const series_range =  norm_assets_series!=null && norm_assets_series.length>0 ? `${norm_assets_series[0]["Date"]} / ${norm_assets_series[norm_assets_series.length-1]["Date"]}` : "";
        const asset_options = norm_assets_series==null || norm_assets_series.length==0 ? null : 
                              [...new Set((this.props.catalog.asset_summ ? unique_values(this.props.catalog.asset_summ, "Name"):[]).concat(norm_assets_series ? array_diff(Object.keys(norm_assets_series[0]), ["Date", "day", "group_var"]):[]))].map(x=>{
                                return { value:x, label:x };
                              });

        const sort_options = [{label:"Volatilidad", value:"Volatilidad Anual."}, {label:"Retorno", value:"Retorno Promedio Anual."}, 
                              {label:"Sharpe", value:"Sharpe"}, {label:"Drawdown", value:"Drawdown"},
                              {label:this.props.catalog.asset_series_per=="1D" ? "Días Negativos" : "Meses Negativos", value:"Negativos"}
                              ].filter(opt=>this.props.catalog.cols_metrics.find(k=>k.name==opt.value)?.active);
        const cols_metrics_form = this.props.catalog.cols_metrics.map((item,i)=>{
          return (
            <div className='row justify-content-start'>
              <div className='col-auto'>
                <Label check>
                  <Input type="checkbox"
                    checked={item.active}
                    onChange={()=>{
                      const cols_metrics_udt = [...this.props.catalog.cols_metrics];
                      cols_metrics_udt[i] = {...item, active:!item.active};
                      this.props.changeModel('catalog.cols_metrics', cols_metrics_udt);
                    }}
                    />
                    {` ${item.name=="Negativos" ? (this.props.catalog.asset_series_per=="1D" ? "Días " : "Meses ") : ""}${item.name}`}
                </Label>
              </div>
            </div>
            );
        });

        return (
          <div className="container">
            {this.renderHeader(series_range)}
            <div className='row m-4 justify-content-center'>
               <div className='col-auto'>
                 {this.props.catalog.asset_tks_list.length>0 && norm_assets_series!==null  && norm_assets_series.length>0 ?
                 <MultLineTsPlot 
                   data={
                    norm_assets_series.map(row => {
                      const out = {};
                      for (const k in row) {
                        out[rename_map[k] || k] = row[k];
                      }
                      return out;
                    })
                   }
                   xkey='Date'
                   ykeys={this.props.catalog.asset_tks_list.map(x=>x.name)}
                   xtype='category'
                   ytype='number'
                   colors = {colors_sura_inv}
                   percTooltip={true}
                   legend={true}
                 />
               :null
                 }
               </div>
            </div>
            <div className='row justify-content-center'>
              <div className='col-auto'>
                {norm_assets_series==null || norm_assets_series.length==0 ? 
                  null : 
                  <CSVLink className='link-btn' 
                    data={norm_assets_series.map(x=>{
                            return filtered_json(x, ['Date'].concat(this.props.catalog.asset_tks_list))
                          })} 
                    filename="series_retorno_total"><small>Descargar retorno total&darr;</small>
                  </CSVLink>}
              </div>
              <div className='col-auto'>
                {this.props.catalog.asset_series==null ? null : <CSVLink className='link-btn' data={this.props.catalog.asset_series.ts} filename="series_precios"><small>Descargar precios&darr;</small></CSVLink>}
              </div>
              <div className='col-auto'>
                {norm_assets_series_per==null ? null : <CSVLink className='link-btn' data={returns_json_array(norm_assets_series_per, "Date")} filename="series_retornos"><small>Descargar retornos&darr;</small></CSVLink>}
              </div>
            </div>
            { assets_summ!==null && assets_summ.length>0 ?
            <Fragment>
              <div className="row justify-content-center">
                <div className="col">
                  <hr/>
                </div>
              </div>
              <div className="row mt-5 justify-content-center" id="summ">
                <div className="col-12">
                  <h5>Métricas</h5>
                  {series_range ?
                    <div className="row justify-content-center" >
                      <div className="col-auto">
                        <p className="m-0"><small>{series_range}</small></p>
                      </div>
                    </div>
                  : null
                  }
                  <a className='linkcol' href='#series'>volver &uarr;</a>
                </div>
              </div>
              {sort_options.length>0 ?
                <div className="row mt-2 justify-content-center">
                  <div className='col-2'>
                    <CustomListSelect
                      className="basic-single"
                      options={sort_options}
                      fontSize={11}
                      itemSize={30}
                      value={this.props.catalog.sort_by}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e)=>this.props.changeModel("catalog.sort_by", e?.value ? {value:e.value, label:e.label} : null)}  
                      placeholder="ordenar por..."
                    />
                  </div>
                </div>
              : null
              }
              <div className="row mt-2 justify-content-center">
                <div className="col-auto">
                  <RenderVirtualTable 
                    data={
                      assets_summ_filtered.map(obj =>
                        Object.fromEntries(
                            Object.entries(obj).filter(([key]) => this.props.catalog.cols_metrics.filter(k=>k.active).map(k=>`${k.name=="Negativos" ? (this.props.catalog.asset_series_per=="1D" ? "Días " : "Meses ") : ""}${k.name}`).includes(key))
                        )
                      ).sort(sort_by(this.props.catalog.sort_by?.value))
                    }
                    to_perc={this.props.catalog.cols_metrics.filter(k=>k.active).map(k=>k.to_perc)} 
                    to_fixed={this.props.catalog.cols_metrics.filter(k=>k.active).map(k=>k.to_fixed)} 
                    cell_width={this.props.catalog.cols_metrics.filter(k=>k.active).map(k=>k.cell_width)}
                    item_size={50}
                    style="black"
                    fontsize={12} 
                  />
                </div>
              </div>
              <div className="row m-1 justify-content-center align-items-center">
                <div className='col-auto'>
                  <CSVLink className='link-btn' 
                    data={assets_summ} 
                    filename="metrics"><small>descargar métricas&darr;</small>
                  </CSVLink>
                </div>
                <div className='col-auto'>
                  <Button className='link-btn'
                    onClick={()=>this.setState({filter_cols:!this.state.filter_cols})}
                  >
                    <small>editar&#9998;</small>
                  </Button>
                </div>
              </div>

              <Modal isOpen={this.state.filter_cols} toggle={()=>this.setState({filter_cols:!this.state.filter_cols})} size="sm">
                <ModalHeader toggle={()=>this.setState({filter_cols:!this.state.filter_cols})}>Filtrar columnas</ModalHeader>
                <ModalBody>
                  {cols_metrics_form}
                </ModalBody>
              </Modal>

              <div className="row mt-3 justify-content-center align-items-end">
                {this.state.calculating_correlations ?
                <div className='col-auto'>
                  <CustomLoading msg="estimando correlaciones" icon="fa-calculator" />
                </div>
                :
                <div className='col-auto'>
                  <Button className='link-btn'
                    onClick={()=>this.calculateCorr(norm_assets_series_per)}
                  >
                    ver correlaciones&#9662;
                  </Button>
                </div>
                }
              </div>
              {this.props.catalog?.corr_matrix!==null ?
              <>
                <div className="row mt-5 justify-content-center" id="summ">
                  <div className="col-12">
                    <h6>Correlaciones</h6>
                  </div>
                </div>
                <div className="row mt-2 justify-content-center">
                  <div className='col-auto'>
                    <RenderVirtualTable 
                      data={this.props.catalog.corr_matrix}
                      to_fixed={[false].concat(new Array(Object.keys(this.props.catalog.corr_matrix[0]).length-1).fill(true))}
                      cell_width={new Array(Object.keys(this.props.catalog.corr_matrix[0]).length-1).fill("130px")}
                      item_size={45}
                      style="black"
                      fontsize={12} />
                  </div>
                </div>
                <div className="row m-2 justify-content-center">
                  <div className="col-6">
                    <Alert
                      color='secondary'
                      isOpen={this.state.msg_corr!=='' && this.state.msg_corr!==null} 
                      toggle={()=>this.setState({msg_corr:null})}
                      fade={false}
                      >
                        {this.state.msg_corr}
                    </Alert>
                  </div>
                </div>

              </>
              :null
              }
            </Fragment>
            :<Fragment></Fragment>
            }
            {asset_options ?
            <>
              <div className="row m-4 justify-content-center">
                <div className="col">
                  <hr/>
                </div>
              </div>
              <div className='row justify-content-center'>
                <div className='col-md-4'>
                  <CustomListSelect
                    maxMenuHeight={100}
                    options={this.props.catalog.asset_tks_list}
                    isClearable={true}
                    value={this.props.catalog.asset_name==null ? null : {value:this.props.catalog.asset_name.value, label:this.props.catalog.asset_name.label}}
                    onChange={(e)=>this.props.changeModel("catalog.asset_name", e==null ? null : {value:e.value, label:e.label.split("|")[0].trim()})}
                    itemSize={50}
                    className="basic-single"
                    placeholder="seleccionar activo"
                  />
                </div>

              </div>
            </>
            :null
            }
            { asset_options && this.props.catalog.asset_summ!==null ?
            <Fragment>
              <div className="row m-4 justify-content-center" id="exp">
                <div className="col-12">
                  <h5>Exposición</h5>
                  <a className='linkcol' href='#series'>volver&uarr;</a>
                </div>
              </div>
              <div className='row justify-content-center m-5'>
                {asset_ac && asset_ac.length>0 ?
                  <div className='col-lg-6'>
                    <h6>Clase</h6>
                    <PiePlot 
                      data={asset_ac.filter(x=>x.value>0.1)} 
                      width={450}
                      height={450}
                      outerRadius={120}
                      percTooltip={true}
                      legend={true}
                      legendHeight={50}
                      dataKey='value'
                      nameKey='name'
                    />
                  </div>
                :
                  <div className='col-6'>
                    <h6>Exposición del activo/producto no encontrada. Intente de nuevo.</h6>
                  </div>
                }
                {asset_mkt && asset_mkt.length>0 ?
                  <div className='col-lg-6'>
                    <h6>Mercado</h6>
                    <PiePlot 
                      data={asset_mkt.filter(x=>x.value>0.1)} 
                      width={450}
                      height={450}
                      outerRadius={120}
                      percTooltip={true}
                      legend={true}
                      legendHeight={50}
                      dataKey='value'
                      nameKey='name'
                    />
                  </div>
                  :null
                }
              </div>

            </Fragment>
            :<Fragment></Fragment>
            }
            {asset_options && asset_total_rets_windows!==null && asset_total_rets_windows.length>0 ?
              <>
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                    <h5>Retornos Realizados</h5>
                    <p><small></small>{series_range}</p>
                  </div>
                </div>
                <div className="row m-5 justify-content-center">
                    <div className='col-lg-6'>
                      <BarPlot 
                        x={asset_total_rets_windows.map(item=>item.name)}
                        y={asset_total_rets_windows.map(item=>item.value)}
                        vertical={false}
                        angle={0}
                        xtype="category" 
                        ytype="number"
                        ypercAxis={true}
                        percTooltip={true}
                        width={500}
                        interval={0}
                        height={400}
                        barsize={20}
                        ml={110}
                      />
                    </div>
                    <div className='col-lg-6'>
                      <BarPlot 
                         y={Object.keys(asset_total_rets)}
                         x={Object.values(asset_total_rets)}
                         layout="vertical"
                         angle={0}
                         ytype="category" xtype="number"
                         color="#000000"
                         xpercAxis={true}
                         percTooltip={true}
                         width={500}
                         interval={0}
                         height={400}
                         barsize={20}
                         ml={110}
                      />
                    </div>
                </div>
              </>
            :null
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(Catalog));